// @flow

import Api from './Api';

export async function httpGet(url: string, params: Object = {}, config?: Object = {}) {
  const { response } = await Api.apiGet(url, params, config).toPromise();

  return response;
}

export async function httpPost(
  url: string,
  body: Object = {},
  params: Object = {},
  config?: Object = {}
) {
  const { response } = await Api.apiPost(url, params, body, config).toPromise();

  return response;
}

export async function httpPut(
  url: string,
  body: Object = {},
  params: Object = {},
  config?: Object = {}
) {
  const { response } = await Api.apiPut(url, params, body, config).toPromise();

  return response;
}

export async function httpDelete(url: string, params: Object = {}, config?: Object = {}) {
  const { response } = await Api.apiDelete(url, params, config).toPromise();

  return response;
}

export default {
  httpGet,
  httpPost,
  httpPut,
  httpDelete
};
